export const getStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
};

export const removeStorage = (key) => {
  return localStorage.removeItem(key);
};

export const setStorage = (key, value) => {
  return localStorage.setItem(key, JSON.stringify(value));
};
